var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackToPhoneNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.371,
    height: 18.63,
    viewBox: "0 0 18.371 18.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.d{fill:none;}.b,.d{stroke:#003142;stroke-linecap:round;}.b{stroke-miterlimit:10;}.c{fill:#003142;}.d{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-678.729 -522.919)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(679 523)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.536 15.865) rotate(172)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.238,12.135l-.854.994A7.765,7.765,0,1,1,15.09,5.177",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.427,2.154V.272A.272.272,0,0,0,2.154,0H.273A.272.272,0,0,0,.08.465L1.962,2.346A.272.272,0,0,0,2.427,2.154Z",
    transform: "translate(12.842 10.845)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M9.527,7.616V8.746a.756.756,0,0,1-.242.558.741.741,0,0,1-.571.2A7.469,7.469,0,0,1,3.26,6.084,7.5,7.5,0,0,1,2.115,2.821a.757.757,0,0,1,.192-.575A.742.742,0,0,1,2.857,2H3.975a.748.748,0,0,1,.746.647,4.872,4.872,0,0,0,.261,1.058.758.758,0,0,1-.168.794l-.474.478A6,6,0,0,0,6.578,7.236l.474-.478a.741.741,0,0,1,.787-.169,4.75,4.75,0,0,0,1.048.264.751.751,0,0,1,.641.764Z",
    transform: "translate(682.18 526.749)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToPhoneNumberIcon);
export default __webpack_public_path__ + "static/media/back-to-phone-number-icon.19b91f69533effafa2628082886ee414.svg";
export { ForwardRef as ReactComponent };